import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
export default function SpotlightBanner({ slides = [], loading }) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (slides.length < 2) return;
    const timer = setInterval(
      () => setIndex((i) => (i + 1) % slides.length),
      7000,
    );
    return () => clearInterval(timer);
  }, [slides.length]);

  if (loading || slides.length === 0) {
    return (
      <div className="card-soft p-4 spotlight-banner shadow-sm">
        <div className="skeleton w-100 h-100" />
      </div>
    );
  }

  const item = slides[index];

  return (
    <div className="spotlight-banner">
      <a
        href={item.link}
        target="_blank"
        rel="noreferrer"
        className="spotlight-link"
      >
        <div
          className="spotlight-bg-blur"
          style={{ backgroundImage: `url(${item.image})` }}
        />

        <img src={item.image} alt="" className="spotlight-img" />
      </a>

      {slides.length > 1 && (
        <div
          className="position-absolute d-flex gap-1"
          style={{ bottom: 14, left: 28, zIndex: 3 }}
        >
          {slides.map((s, i) => (
            <button
              key={s.id}
              onClick={() => setIndex(i)}
              aria-label={`Show slide ${i + 1}`}
              className={`dot-indicator ${i === index ? "active" : ""}`}
            />
          ))}
        </div>
      )}
    </div>
  );
}
SpotlightBanner.propTypes = {
  slides: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      image: PropTypes.string,
      link: PropTypes.string,
    }),
  ),
  loading: PropTypes.bool,
};
